const featured = {
  scale: 'Enterprise · Est. 1957',
  quote: "Safari pricing is genuinely complex — seasonal rates, child policies, occupancy rules, meal plan combinations that vary by property. For decades we managed this manually, and the margin for error was always there. Twigaa changed that fundamentally. The system understands our lodge contracts the way our best reservations consultants do — and it applies the right rates automatically, every time. What used to take hours now takes minutes, which means we respond to agent enquiries faster and convert more bookings. Beyond the quoting, our operations team relies on Twigaa daily — coordinating ground logistics, managing supplier communications, and ensuring every moving part of a safari runs as it should. And our accounts department and CFO have complete financial visibility in real time. Everyone works from the same system — reservations, operations, accounts — all on one platform. It is not software we use occasionally. It is the system our entire business runs on.",
  name: 'Glen Rawlings',
  title: 'Managing Director, Southern Cross Safaris — Mombasa, Kenya',
  avatar: './img/GlenRawlings.jpg',
};

const testimonials = [
  {
    scale: 'SME · Small team',
    sme: true,
    quote: "We've been with Twigaa from the very beginning — through the early days, the iterations, the improvements. What kept us was not just the product getting better but knowing the team genuinely listened. Now each consultant handles more enquiries, quotes faster, and makes fewer errors than we ever did manually. Twigaa gave a small operation like ours the capability of a much larger one.",
    name: 'Monica Solanki',
    title: 'Owner, Lofty Tours, Mombasa',
    avatar: './img/monicasolankiimage.jpeg',
  },
  {
    scale: 'SME · Small team',
    sme: true,
    quote: "Choosing Twigaa.ai for cost analysis and crafting tourism itineraries was a brilliant decision. The itinerary planning feature is a game-changer – it suggests personalized, engaging routes based on user preferences. The time saved and the level of detail in our itineraries have exceeded our expectations. The support team's expertise and responsiveness have further solidified our confidence in the system. Thanks to Twigaa.ai, we've not only improved efficiency but also enhanced the overall travel experience for our clients. Highly recommend!",
    name: 'Catherine',
    title: 'GM, Nature Surf Africa Safaris',
    avatar: './img/naturesurf.jpeg',
  },
];

function initials(name) {
  return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

function Attrib({ name, title, avatar }) {
  return (
    <div className="attrib">
      {avatar ? (
        <img
          src={avatar}
          alt={name}
          style={{
            width: 36, height: 36, borderRadius: '50%',
            objectFit: 'cover', flex: '0 0 auto',
            border: '1px solid var(--line-strong)',
          }}
        />
      ) : (
        <div style={{
          width: 36, height: 36, borderRadius: '50%',
          background: 'var(--ink-3)', border: '1px solid var(--line-strong)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: "'IBM Plex Mono',monospace", fontSize: '.7rem',
          color: 'var(--green)', flex: '0 0 auto',
        }}>
          {initials(name)}
        </div>
      )}
      <div>
        <div className="n">{name}</div>
        <div className="t">{title}</div>
      </div>
    </div>
  );
}

const TestimonialsGrid = ({ innerRef }) => (
  <section ref={innerRef}>
    <div className="wrap">
      <div className="section-head">
        <p className="eyebrow">Operators running on it</p>
        <h2>One engine. Whatever size you are.</h2>
      </div>

      {/* Featured enterprise quote — full width, full text, no height constraint */}
      <div className="quote featured" style={{ marginTop: 40 }}>
        <span className="scale">{featured.scale}</span>
        <blockquote>{featured.quote}</blockquote>
        <Attrib name={featured.name} title={featured.title} avatar={featured.avatar} />
      </div>

      {/* Supporting SME quotes — side by side */}
      <div className="quotes" style={{ marginTop: 22 }}>
        {testimonials.map((t, i) => (
          <div className={`quote${t.sme ? ' sme' : ''}`} key={i}>
            <span className="scale">{t.scale}</span>
            <blockquote>{t.quote}</blockquote>
            <Attrib name={t.name} title={t.title} avatar={t.avatar} />
          </div>
        ))}
      </div>

      <p className="same-engine">100 itineraries a day &nbsp;·&nbsp; zero churn &nbsp;·&nbsp; <b>same rate engine at both ends</b></p>
    </div>
  </section>
);

export default TestimonialsGrid;